module.exports = __webpack_public_path__ + "img/hw-a555.65499f55.png";